import React, {useEffect, useState} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';

const UserCreditLimit = ({
                             getUserCreditLimit,
                             userCreditLimit = []
                         }) => {


    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getUserCreditLimit(1)
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        'Name',
        'Role',
        'Current Limit',
        'Hold Amount',
        'Owed Amount',
        'Actions'
    ];

    useEffect(() => {
        if (userCreditLimit && userCreditLimit?.data && userCreditLimit?.data.length > 0) {
            const tableData = ['id','name', 'title', 'wallet_balance', 'hold_amt', 'owed_amt'];
            const action = [{name: 'Add Credit limit', link: `/dashboard/user-credit-limit`}];
            const data = userCreditLimit?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'wallet_balance' && element['wallet_balance'] === null ? {['wallet_balance']: 0} :
                        key === 'hold_amt' && element['hold_amt'] === null ? {['hold_amt']: 0} :
                        key === 'owed_amt' && element['owed_amt'] === null ? {['owed_amt']: 0} :
                        {[key]: element[key]}
                    )),
                    {},
                    {Action: action}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(userCreditLimit.total / userCreditLimit.per_page));
        }
    }, [userCreditLimit])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getUserCreditLimit(val.selected + 1);
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.userCreditLimit}
            isLoading={isLoading}
            isGoback={true}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={userCreditLimit && userCreditLimit.data}
                srNo={userCreditLimit?.from}
            />
        </Layout>
    )
}

export default UserCreditLimit